export default __webpack_public_path__ + "static/media/PhoneLogo.fba06aa7.png";